{
  "minecraft:grass_block": {
    "snowy": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:podzol": {
    "snowy": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:oak_sapling": {
    "stage": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1
      ]
    }
  },
  "minecraft:spruce_sapling": {
    "stage": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1
      ]
    }
  },
  "minecraft:birch_sapling": {
    "stage": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1
      ]
    }
  },
  "minecraft:jungle_sapling": {
    "stage": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1
      ]
    }
  },
  "minecraft:acacia_sapling": {
    "stage": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1
      ]
    }
  },
  "minecraft:dark_oak_sapling": {
    "stage": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1
      ]
    }
  },
  "minecraft:water": {
    "level": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:lava": {
    "level": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:oak_log": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:spruce_log": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:birch_log": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:jungle_log": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:acacia_log": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:dark_oak_log": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_spruce_log": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_birch_log": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_jungle_log": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_acacia_log": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_dark_oak_log": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_oak_log": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:oak_wood": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:spruce_wood": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:birch_wood": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:jungle_wood": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:acacia_wood": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:dark_oak_wood": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_oak_wood": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_spruce_wood": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_birch_wood": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_jungle_wood": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_acacia_wood": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_dark_oak_wood": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:oak_leaves": {
    "distance": {
      "default": 7,
      "type": "int",
      "valueType": "int",
      "values": [
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    },
    "persistent": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:spruce_leaves": {
    "distance": {
      "default": 7,
      "type": "int",
      "valueType": "int",
      "values": [
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    },
    "persistent": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:birch_leaves": {
    "distance": {
      "default": 7,
      "type": "int",
      "valueType": "int",
      "values": [
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    },
    "persistent": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:jungle_leaves": {
    "distance": {
      "default": 7,
      "type": "int",
      "valueType": "int",
      "values": [
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    },
    "persistent": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:acacia_leaves": {
    "distance": {
      "default": 7,
      "type": "int",
      "valueType": "int",
      "values": [
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    },
    "persistent": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_oak_leaves": {
    "distance": {
      "default": 7,
      "type": "int",
      "valueType": "int",
      "values": [
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    },
    "persistent": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dispenser": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    },
    "triggered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:note_block": {
    "instrument": {
      "default": "HARP",
      "type": "enum",
      "valueType": "Instrument",
      "values": [
        "HARP",
        "BASEDRUM",
        "SNARE",
        "HAT",
        "BASS",
        "FLUTE",
        "BELL",
        "GUITAR",
        "CHIME",
        "XYLOPHONE",
        "IRON_XYLOPHONE",
        "COW_BELL",
        "DIDGERIDOO",
        "BIT",
        "BANJO",
        "PLING"
      ]
    },
    "note": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:white_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:orange_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:magenta_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:light_blue_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:yellow_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:lime_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:pink_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:gray_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:light_gray_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:cyan_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:purple_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:blue_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:brown_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:green_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:red_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:black_bed": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "occupied": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "part": {
      "default": "foot",
      "type": "enum",
      "valueType": "BedPart",
      "values": [
        "head",
        "foot"
      ]
    }
  },
  "minecraft:powered_rail": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "shape": {
      "default": "north_south",
      "type": "enum",
      "valueType": "RailShape",
      "values": [
        "north_south",
        "east_west",
        "ascending_east",
        "ascending_west",
        "ascending_north",
        "ascending_south"
      ]
    }
  },
  "minecraft:detector_rail": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "shape": {
      "default": "north_south",
      "type": "enum",
      "valueType": "RailShape",
      "values": [
        "north_south",
        "east_west",
        "ascending_east",
        "ascending_west",
        "ascending_north",
        "ascending_south"
      ]
    }
  },
  "minecraft:sticky_piston": {
    "extended": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:tall_seagrass": {
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    }
  },
  "minecraft:piston": {
    "extended": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:piston_head": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    },
    "short": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "type": {
      "default": "normal",
      "type": "enum",
      "valueType": "PistonType",
      "values": [
        "normal",
        "sticky"
      ]
    }
  },
  "minecraft:moving_piston": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    },
    "type": {
      "default": "normal",
      "type": "enum",
      "valueType": "PistonType",
      "values": [
        "normal",
        "sticky"
      ]
    }
  },
  "minecraft:tnt": {
    "unstable": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:wall_torch": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:fire": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    },
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "up": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:oak_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:chest": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "type": {
      "default": "SINGLE",
      "type": "enum",
      "valueType": "ChestType",
      "values": [
        "SINGLE",
        "LEFT",
        "RIGHT"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:redstone_wire": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WireConnection",
      "values": [
        "up",
        "side",
        "none"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WireConnection",
      "values": [
        "up",
        "side",
        "none"
      ]
    },
    "power": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WireConnection",
      "values": [
        "up",
        "side",
        "none"
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WireConnection",
      "values": [
        "up",
        "side",
        "none"
      ]
    }
  },
  "minecraft:wheat": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    }
  },
  "minecraft:farmland": {
    "moisture": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    }
  },
  "minecraft:furnace": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "lit": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:oak_sign": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:spruce_sign": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:birch_sign": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:acacia_sign": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:jungle_sign": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_oak_sign": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:oak_door": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    },
    "hinge": {
      "default": "left",
      "type": "enum",
      "valueType": "DoorHinge",
      "values": [
        "left",
        "right"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:ladder": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:rail": {
    "shape": {
      "default": "north_south",
      "type": "enum",
      "valueType": "RailShape",
      "values": [
        "north_south",
        "east_west",
        "ascending_east",
        "ascending_west",
        "ascending_north",
        "ascending_south",
        "south_east",
        "south_west",
        "north_west",
        "north_east"
      ]
    }
  },
  "minecraft:cobblestone_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:oak_wall_sign": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:spruce_wall_sign": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:birch_wall_sign": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:acacia_wall_sign": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:jungle_wall_sign": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_oak_wall_sign": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:lever": {
    "face": {
      "default": "WALL",
      "type": "enum",
      "valueType": "WallMountLocation",
      "values": [
        "FLOOR",
        "WALL",
        "CEILING"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:stone_pressure_plate": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:iron_door": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    },
    "hinge": {
      "default": "left",
      "type": "enum",
      "valueType": "DoorHinge",
      "values": [
        "left",
        "right"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:oak_pressure_plate": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:spruce_pressure_plate": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:birch_pressure_plate": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:jungle_pressure_plate": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:acacia_pressure_plate": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_oak_pressure_plate": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:redstone_ore": {
    "lit": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:redstone_torch": {
    "lit": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:redstone_wall_torch": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "lit": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:stone_button": {
    "face": {
      "default": "WALL",
      "type": "enum",
      "valueType": "WallMountLocation",
      "values": [
        "FLOOR",
        "WALL",
        "CEILING"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:snow": {
    "layers": {
      "default": 1,
      "type": "int",
      "valueType": "int",
      "values": [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
      ]
    }
  },
  "minecraft:cactus": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:sugar_cane": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:jukebox": {
    "has_record": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:oak_fence": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:basalt": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:polished_basalt": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:soul_wall_torch": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:nether_portal": {
    "axis": {
      "default": "x",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "z"
      ]
    }
  },
  "minecraft:carved_pumpkin": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:jack_o_lantern": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:cake": {
    "bites": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6
      ]
    }
  },
  "minecraft:repeater": {
    "delay": {
      "default": 1,
      "type": "int",
      "valueType": "int",
      "values": [
        1,
        2,
        3,
        4
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "locked": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:oak_trapdoor": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:spruce_trapdoor": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:birch_trapdoor": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:jungle_trapdoor": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:acacia_trapdoor": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_oak_trapdoor": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:brown_mushroom_block": {
    "down": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "east": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:red_mushroom_block": {
    "down": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "east": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:mushroom_stem": {
    "down": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "east": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:iron_bars": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:chain": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:attached_pumpkin_stem": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:attached_melon_stem": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:pumpkin_stem": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    }
  },
  "minecraft:melon_stem": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    }
  },
  "minecraft:vine": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "up": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:oak_fence_gate": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "in_wall": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:brick_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:stone_brick_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:mycelium": {
    "snowy": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:nether_brick_fence": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:nether_brick_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:nether_wart": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3
      ]
    }
  },
  "minecraft:brewing_stand": {
    "has_bottle_0": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "has_bottle_1": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "has_bottle_2": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:cauldron": {
    "level": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3
      ]
    }
  },
  "minecraft:end_portal_frame": {
    "eye": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:redstone_lamp": {
    "lit": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:cocoa": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:sandstone_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:ender_chest": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:tripwire_hook": {
    "attached": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:tripwire": {
    "attached": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "disarmed": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:spruce_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:birch_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:jungle_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:command_block": {
    "conditional": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:cobblestone_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:mossy_cobblestone_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:carrots": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    }
  },
  "minecraft:potatoes": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    }
  },
  "minecraft:oak_button": {
    "face": {
      "default": "WALL",
      "type": "enum",
      "valueType": "WallMountLocation",
      "values": [
        "FLOOR",
        "WALL",
        "CEILING"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:spruce_button": {
    "face": {
      "default": "WALL",
      "type": "enum",
      "valueType": "WallMountLocation",
      "values": [
        "FLOOR",
        "WALL",
        "CEILING"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:birch_button": {
    "face": {
      "default": "WALL",
      "type": "enum",
      "valueType": "WallMountLocation",
      "values": [
        "FLOOR",
        "WALL",
        "CEILING"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:jungle_button": {
    "face": {
      "default": "WALL",
      "type": "enum",
      "valueType": "WallMountLocation",
      "values": [
        "FLOOR",
        "WALL",
        "CEILING"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:acacia_button": {
    "face": {
      "default": "WALL",
      "type": "enum",
      "valueType": "WallMountLocation",
      "values": [
        "FLOOR",
        "WALL",
        "CEILING"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_oak_button": {
    "face": {
      "default": "WALL",
      "type": "enum",
      "valueType": "WallMountLocation",
      "values": [
        "FLOOR",
        "WALL",
        "CEILING"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:skeleton_skull": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:skeleton_wall_skull": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:wither_skeleton_skull": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:wither_skeleton_wall_skull": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:zombie_head": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:zombie_wall_head": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:player_head": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:player_wall_head": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:creeper_head": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:creeper_wall_head": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:dragon_head": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:dragon_wall_head": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:anvil": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:chipped_anvil": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:damaged_anvil": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:trapped_chest": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "type": {
      "default": "SINGLE",
      "type": "enum",
      "valueType": "ChestType",
      "values": [
        "SINGLE",
        "LEFT",
        "RIGHT"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:light_weighted_pressure_plate": {
    "power": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:heavy_weighted_pressure_plate": {
    "power": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:comparator": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "mode": {
      "default": "compare",
      "type": "enum",
      "valueType": "ComparatorMode",
      "values": [
        "compare",
        "subtract"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:daylight_detector": {
    "inverted": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "power": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:hopper": {
    "enabled": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "facing": {
      "default": "down",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "down",
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:quartz_pillar": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:quartz_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:activator_rail": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "shape": {
      "default": "north_south",
      "type": "enum",
      "valueType": "RailShape",
      "values": [
        "north_south",
        "east_west",
        "ascending_east",
        "ascending_west",
        "ascending_north",
        "ascending_south"
      ]
    }
  },
  "minecraft:dropper": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    },
    "triggered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:white_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:orange_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:magenta_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:light_blue_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:yellow_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:lime_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:pink_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:gray_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:light_gray_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:cyan_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:purple_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:blue_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:brown_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:green_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:red_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:black_stained_glass_pane": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:acacia_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_oak_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:iron_trapdoor": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:prismarine_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:prismarine_brick_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_prismarine_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:prismarine_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:prismarine_brick_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_prismarine_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:hay_block": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:sunflower": {
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    }
  },
  "minecraft:lilac": {
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    }
  },
  "minecraft:rose_bush": {
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    }
  },
  "minecraft:peony": {
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    }
  },
  "minecraft:tall_grass": {
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    }
  },
  "minecraft:large_fern": {
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    }
  },
  "minecraft:white_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:orange_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:magenta_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:light_blue_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:yellow_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:lime_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:pink_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:gray_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:light_gray_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:cyan_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:purple_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:blue_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:brown_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:green_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:red_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:black_banner": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:white_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:orange_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:magenta_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:light_blue_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:yellow_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:lime_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:pink_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:gray_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:light_gray_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:cyan_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:purple_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:blue_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:brown_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:green_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:red_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:black_wall_banner": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:red_sandstone_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:oak_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:spruce_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:birch_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:jungle_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:acacia_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_oak_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:stone_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:smooth_stone_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:sandstone_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:cut_sandstone_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:petrified_oak_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:cobblestone_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:brick_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:stone_brick_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:nether_brick_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:quartz_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:red_sandstone_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:cut_red_sandstone_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:purpur_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:spruce_fence_gate": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "in_wall": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:birch_fence_gate": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "in_wall": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:jungle_fence_gate": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "in_wall": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:acacia_fence_gate": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "in_wall": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_oak_fence_gate": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "in_wall": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:spruce_fence": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:birch_fence": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:jungle_fence": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:acacia_fence": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_oak_fence": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:spruce_door": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    },
    "hinge": {
      "default": "left",
      "type": "enum",
      "valueType": "DoorHinge",
      "values": [
        "left",
        "right"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:birch_door": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    },
    "hinge": {
      "default": "left",
      "type": "enum",
      "valueType": "DoorHinge",
      "values": [
        "left",
        "right"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:jungle_door": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    },
    "hinge": {
      "default": "left",
      "type": "enum",
      "valueType": "DoorHinge",
      "values": [
        "left",
        "right"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:acacia_door": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    },
    "hinge": {
      "default": "left",
      "type": "enum",
      "valueType": "DoorHinge",
      "values": [
        "left",
        "right"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dark_oak_door": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    },
    "hinge": {
      "default": "left",
      "type": "enum",
      "valueType": "DoorHinge",
      "values": [
        "left",
        "right"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:end_rod": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:chorus_plant": {
    "down": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "up": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:chorus_flower": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5
      ]
    }
  },
  "minecraft:purpur_pillar": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:purpur_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:beetroots": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3
      ]
    }
  },
  "minecraft:repeating_command_block": {
    "conditional": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:chain_command_block": {
    "conditional": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:frosted_ice": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3
      ]
    }
  },
  "minecraft:bone_block": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:observer": {
    "facing": {
      "default": "south",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:white_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:orange_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:magenta_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:light_blue_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:yellow_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:lime_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:pink_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:gray_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:light_gray_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:cyan_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:purple_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:blue_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:brown_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:green_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:red_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:black_shulker_box": {
    "facing": {
      "default": "up",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    }
  },
  "minecraft:white_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:orange_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:magenta_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:light_blue_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:yellow_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:lime_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:pink_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:gray_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:light_gray_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:cyan_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:purple_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:blue_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:brown_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:green_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:red_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:black_glazed_terracotta": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:kelp": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25
      ]
    }
  },
  "minecraft:turtle_egg": {
    "eggs": {
      "default": 1,
      "type": "int",
      "valueType": "int",
      "values": [
        1,
        2,
        3,
        4
      ]
    },
    "hatch": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2
      ]
    }
  },
  "minecraft:dead_tube_coral": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_brain_coral": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_bubble_coral": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_fire_coral": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_horn_coral": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:tube_coral": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:brain_coral": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:bubble_coral": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:fire_coral": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:horn_coral": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_tube_coral_fan": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_brain_coral_fan": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_bubble_coral_fan": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_fire_coral_fan": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_horn_coral_fan": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:tube_coral_fan": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:brain_coral_fan": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:bubble_coral_fan": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:fire_coral_fan": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:horn_coral_fan": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_tube_coral_wall_fan": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_brain_coral_wall_fan": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_bubble_coral_wall_fan": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_fire_coral_wall_fan": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:dead_horn_coral_wall_fan": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:tube_coral_wall_fan": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:brain_coral_wall_fan": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:bubble_coral_wall_fan": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:fire_coral_wall_fan": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:horn_coral_wall_fan": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:sea_pickle": {
    "pickles": {
      "default": 1,
      "type": "int",
      "valueType": "int",
      "values": [
        1,
        2,
        3,
        4
      ]
    },
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:conduit": {
    "waterlogged": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:bamboo": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1
      ]
    },
    "leaves": {
      "default": "none",
      "type": "enum",
      "valueType": "BambooLeaves",
      "values": [
        "none",
        "small",
        "large"
      ]
    },
    "stage": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1
      ]
    }
  },
  "minecraft:bubble_column": {
    "drag": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_granite_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:smooth_red_sandstone_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:mossy_stone_brick_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_diorite_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:mossy_cobblestone_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:end_stone_brick_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:stone_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:smooth_sandstone_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:smooth_quartz_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:granite_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:andesite_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:red_nether_brick_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_andesite_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:diorite_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_granite_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:smooth_red_sandstone_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:mossy_stone_brick_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_diorite_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:mossy_cobblestone_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:end_stone_brick_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:smooth_sandstone_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:smooth_quartz_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:granite_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:andesite_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:red_nether_brick_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_andesite_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:diorite_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:brick_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:prismarine_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:red_sandstone_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:mossy_stone_brick_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:granite_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:stone_brick_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:nether_brick_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:andesite_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:red_nether_brick_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:sandstone_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:end_stone_brick_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:diorite_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:scaffolding": {
    "bottom": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "distance": {
      "default": 7,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:loom": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:barrel": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "east",
        "south",
        "west",
        "up",
        "down"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:smoker": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "lit": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:blast_furnace": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "lit": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:grindstone": {
    "face": {
      "default": "WALL",
      "type": "enum",
      "valueType": "WallMountLocation",
      "values": [
        "FLOOR",
        "WALL",
        "CEILING"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:lectern": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "has_book": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:stonecutter": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    }
  },
  "minecraft:bell": {
    "attachment": {
      "default": "FLOOR",
      "type": "enum",
      "valueType": "Attachment",
      "values": [
        "FLOOR",
        "CEILING",
        "SINGLE_WALL",
        "DOUBLE_WALL"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:lantern": {
    "hanging": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:soul_lantern": {
    "hanging": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:campfire": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "lit": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "signal_fire": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:soul_campfire": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "lit": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "signal_fire": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:sweet_berry_bush": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3
      ]
    }
  },
  "minecraft:warped_stem": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_warped_stem": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:warped_hyphae": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_warped_hyphae": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:crimson_stem": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_crimson_stem": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:crimson_hyphae": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:stripped_crimson_hyphae": {
    "axis": {
      "default": "y",
      "type": "enum",
      "valueType": "Axis",
      "values": [
        "x",
        "y",
        "z"
      ]
    }
  },
  "minecraft:weeping_vines": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25
      ]
    }
  },
  "minecraft:twisting_vines": {
    "age": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25
      ]
    }
  },
  "minecraft:crimson_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:warped_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:crimson_pressure_plate": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:warped_pressure_plate": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:crimson_fence": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:warped_fence": {
    "east": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "north": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "south": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:crimson_trapdoor": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:warped_trapdoor": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:crimson_fence_gate": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "in_wall": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:warped_fence_gate": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "in_wall": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:crimson_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:warped_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:crimson_button": {
    "face": {
      "default": "WALL",
      "type": "enum",
      "valueType": "WallMountLocation",
      "values": [
        "FLOOR",
        "WALL",
        "CEILING"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:warped_button": {
    "face": {
      "default": "WALL",
      "type": "enum",
      "valueType": "WallMountLocation",
      "values": [
        "FLOOR",
        "WALL",
        "CEILING"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:crimson_door": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    },
    "hinge": {
      "default": "left",
      "type": "enum",
      "valueType": "DoorHinge",
      "values": [
        "left",
        "right"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:warped_door": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "lower",
      "type": "enum",
      "valueType": "DoubleBlockHalf",
      "values": [
        "upper",
        "lower"
      ]
    },
    "hinge": {
      "default": "left",
      "type": "enum",
      "valueType": "DoorHinge",
      "values": [
        "left",
        "right"
      ]
    },
    "open": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:crimson_sign": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:warped_sign": {
    "rotation": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:crimson_wall_sign": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:warped_wall_sign": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:structure_block": {
    "mode": {
      "default": "SAVE",
      "type": "enum",
      "valueType": "StructureBlockMode",
      "values": [
        "SAVE",
        "LOAD",
        "CORNER",
        "DATA"
      ]
    }
  },
  "minecraft:jigsaw": {
    "orientation": {
      "default": "NORTH_UP",
      "type": "enum",
      "valueType": "JigsawOrientation",
      "values": [
        "DOWN_EAST",
        "DOWN_NORTH",
        "DOWN_SOUTH",
        "DOWN_WEST",
        "UP_EAST",
        "UP_NORTH",
        "UP_SOUTH",
        "UP_WEST",
        "WEST_UP",
        "EAST_UP",
        "NORTH_UP",
        "SOUTH_UP"
      ]
    }
  },
  "minecraft:composter": {
    "level": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
      ]
    }
  },
  "minecraft:target": {
    "power": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ]
    }
  },
  "minecraft:bee_nest": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "honey_level": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5
      ]
    }
  },
  "minecraft:beehive": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "honey_level": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4,
        5
      ]
    }
  },
  "minecraft:respawn_anchor": {
    "charges": {
      "default": 0,
      "type": "int",
      "valueType": "int",
      "values": [
        0,
        1,
        2,
        3,
        4
      ]
    }
  },
  "minecraft:blackstone_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:blackstone_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:blackstone_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_blackstone_brick_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_blackstone_brick_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_blackstone_brick_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  },
  "minecraft:polished_blackstone_stairs": {
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "half": {
      "default": "bottom",
      "type": "enum",
      "valueType": "BlockHalf",
      "values": [
        "top",
        "bottom"
      ]
    },
    "shape": {
      "default": "straight",
      "type": "enum",
      "valueType": "StairShape",
      "values": [
        "straight",
        "inner_left",
        "inner_right",
        "outer_left",
        "outer_right"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_blackstone_slab": {
    "type": {
      "default": "bottom",
      "type": "enum",
      "valueType": "SlabType",
      "values": [
        "top",
        "bottom",
        "double"
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_blackstone_pressure_plate": {
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_blackstone_button": {
    "face": {
      "default": "WALL",
      "type": "enum",
      "valueType": "WallMountLocation",
      "values": [
        "FLOOR",
        "WALL",
        "CEILING"
      ]
    },
    "facing": {
      "default": "north",
      "type": "enum",
      "valueType": "Direction",
      "values": [
        "north",
        "south",
        "west",
        "east"
      ]
    },
    "powered": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    }
  },
  "minecraft:polished_blackstone_wall": {
    "east": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "north": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "south": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    },
    "up": {
      "default": true,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "waterlogged": {
      "default": false,
      "type": "boolean",
      "valueType": "boolean",
      "values": [
        true,
        false
      ]
    },
    "west": {
      "default": "none",
      "type": "enum",
      "valueType": "WallShape",
      "values": [
        "none",
        "low",
        "tall"
      ]
    }
  }
}
